export const attendance = {
  updateFail: 'Update Attendance fail!',
  updateSuccessfully: 'Update Attendance successfully!',
  createFail: 'Create Attendance fail!',
  createSuccessfully: 'Create Attendance success!',
  deleteSuccessfully: 'Delete Attendance successfully!',
  deleteFail: 'Delete Attendance fail!',
}
